import React, { Fragment } from "react";
import { useTranslation } from 'react-i18next';

export default function (props) {
    const { t } = useTranslation();

    const { payment, isKlarna, isOpenpay, saleTotal, isInvoice, isMobilePay } = props;
    if (!payment) return <div />;
    const isCardPayment = isKlarna !== true && isOpenpay !== true && isInvoice !== true && isMobilePay != true;
    const cardLastdigits = payment.number ? payment.number.substring(payment.number.trim().length - 4) : "";
    return (
        <div className="row padding-top-1x mt-3">
            <div className="col-sm-12">
                <h5>{t("Payment method")}:</h5>
                <ul className="list-unstyled">
                    {isCardPayment &&
                        <Fragment>
                            <li>
                                <span className="text-muted">{t("Credit Card")}:</span> **** **** **** {cardLastdigits}
                            </li>
                            <li>
                                <span className="text-muted">{t("Name")}:</span>{payment.name}
                            </li>
                        </Fragment>
                    }
                    {isInvoice &&
                        <Fragment>
                            <li>
                                <span className="text-muted">{t("Invoice Payment")}</span>
                            </li>
                        </Fragment>
                    }
                    {isKlarna && <li>
                        <img src="img/Klarna/Klarna-logo.svg" />
                    </li>}
                    {isOpenpay && <li>
                        <opy-cart amount={saleTotal} logo="grey-on-amberbg" more-info-text={t("More info")}  ></opy-cart>
                    </li>}
                    {isMobilePay &&  <Fragment>
                            <li>
                            <img className="payment-img" src="img/MobilePay/VippsMobilePay_Logo_Primary_RGB_Black.svg" alt="Vipps logo" />
                         
                            </li>
                        </Fragment>}
                    

                </ul>
            </div>
        </div>
    );
}
